import { render, staticRenderFns } from "./form4Accreditation.vue?vue&type=template&id=00b61bde&scoped=true"
import script from "./form4Accreditation.vue?vue&type=script&lang=js"
export * from "./form4Accreditation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b61bde",
  null
  
)

export default component.exports